import { render, staticRenderFns } from "./OrderItemStatus.vue?vue&type=template&id=182d53c7&scoped=true&"
import script from "./OrderItemStatus.vue?vue&type=script&lang=js&"
export * from "./OrderItemStatus.vue?vue&type=script&lang=js&"
import style0 from "./OrderItemStatus.vue?vue&type=style&index=0&id=182d53c7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182d53c7",
  null
  
)

export default component.exports